import React, { useState, useContext, useEffect } from "react"
import blogFetch from "../../axios/config";
import Context from "../../context/Context";
import Button from "@mui/material/Button";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import toast from "react-hot-toast";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import language from "../../nls/language.json";
import { ExpandMore } from "@mui/icons-material";
import { AddPieceModal, EditPieceModal } from "./modals";
import './Combinations.css';

const INITIAL_ADD_PRODUTO = {
  pecaGrupo_CodPeca: "",
  pecaGrupo_Nome: ""
};

const PECA = "PECA";
const EDIT_PECA = "EDIT_PECA";

export default function PiecesTable() {
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [ShowModalEdit, setShowModalEdit] = useState(false);

  const [selectedPieces, setSelectedPieces] = useState({})
  const [selectedAddPieces, setSelectedAddPieces] = useState(INITIAL_ADD_PRODUTO)

  const [grupoPecas, setGrupoPecas] = useState([]);
  const [pecasOptions, setPecasOptions] = useState([]);

  const {
    selectedCountry,
  } = useContext(Context);

  useEffect(() => {
    getGrupoPecas();
    getPecasOptions();
  }, [])

  const getGrupoPecas = async () => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_TipoPecaGrupo/grupoNome/pieces`);
      setGrupoPecas(data);
    } catch (error) {
      console.error(error);
    }
  }

  const getPecasOptions = async () => {
    try {
      const { data } = await blogFetch.get('/SAGA_Caracteristicas/pecas');
      setPecasOptions(data);
    } catch (error) {
      console.error(error);
    }
  }

  const postPieces = async (data) => {
    try {
      await blogFetch.post('/ISAGA_TipoPecaGrupo', data);

      setShowModalAdd(false);
      getGrupoPecas();
      toast.success(language[selectedCountry.name].Cadastro.combinacoes.notification.successAdd, {
        duration: 4000,
      });
    } catch (error) {
      console.error(error);
      toast.error(language[selectedCountry.name].Cadastro.combinacoes.notification.errorAdd, {
        duration: 4000,
      });
    }
  }

  const putPieces = async (data) => {
    try {
      await blogFetch.put(`/ISAGA_TipoPecaGrupo`, data);
      toast.success(language[selectedCountry.name].Cadastro.combinacoes.notification.successUpdate, {
        duration: 4000,
      });
      getGrupoPecas();
      setShowModalEdit(false);
    } catch (error) {
      console.error(error);
      toast.error(language[selectedCountry.name].Cadastro.combinacoes.notification.errorUpdate, {
        duration: 4000,
      });
    }
  }

  const handleSelectedAddPieces = () => {
    setSelectedAddPieces(INITIAL_ADD_PRODUTO);
    setShowModalAdd(true);
  }

  const handleSelectedPieces = (data) => {
    setSelectedPieces(data);
    setShowModalEdit(true);
  }

  const handleAddPieces = ({ name, value }, type) => {
    switch (type) {
      case PECA:
        setSelectedAddPieces({
          ...selectedAddPieces,
          [name]: value.toUpperCase()
        });
        break;
      case EDIT_PECA:
        setSelectedPieces({
          ...selectedPieces,
          [name]: value.toUpperCase()
        });
        break;
    }
  }

  const checkSaveBtn = (data) => !(data.pecaGrupo_CodPeca && data.pecaGrupo_Nome);

  return (
    <>
      <div>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
              {language[selectedCountry.name].Cadastro.combinacoes.pecas.title}
            </h3>
          </div>
          <div>
            <Button
              className="btn add_button"
              variant="primary"
              onClick={() => handleSelectedAddPieces()}
            >
              {language[selectedCountry.name].Cadastro.combinacoes.pecas.btnAdicionar}
            </Button>
          </div>
        </div>
        {grupoPecas.map((item, i) => (
          <Accordion key={`grupoPecas-${i}`}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              className="header-flex accordionSummary"
            >
              <p className="forno-text">{item.prodGrupo_GrupoNome}</p>
            </AccordionSummary>
            <AccordionDetails>
              <table className="table table-hover">
                <thead className="table-header">
                  <tr className="table_row">
                    <th>{language[selectedCountry.name].Cadastro.combinacoes.pecas.tableHeader.nome}</th>
                    <th>{language[selectedCountry.name].Cadastro.combinacoes.pecas.tableHeader.grupo}</th>
                    <th>{language[selectedCountry.name].Cadastro.combinacoes.pecas.tableHeader.editar}</th>
                  </tr>
                </thead>
                <tbody className="table_row">
                  {item.pieces.map((itemProd, indexItemProd) => (
                    <tr key={`grupoPecas-table-${indexItemProd}`}>
                      <td>{itemProd.pecaGrupo_CodPeca}</td>
                      <td>{itemProd.pecaGrupo_Nome}</td>
                      <th className="edit">
                        <center>
                          <ModeEditIcon
                            color="info"
                            onClick={() => handleSelectedPieces(itemProd)}
                          />
                        </center>
                      </th>
                    </tr>
                  ))}
                </tbody>
              </table>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
      <AddPieceModal
        showModalAdd={showModalAdd}
        setShowModalAdd={setShowModalAdd}
        handleAddPieces={handleAddPieces}
        selectedAddPieces={selectedAddPieces}
        grupoPecas={grupoPecas}
        pecasOptions={pecasOptions}
        postPieces={postPieces}
        checkSaveBtn={checkSaveBtn}
      />
      <EditPieceModal
        ShowModalEdit={ShowModalEdit}
        setShowModalEdit={setShowModalEdit}
        handleAddPieces={handleAddPieces}
        selectedPieces={selectedPieces}
        grupoPecas={grupoPecas}
        pecasOptions={pecasOptions}
        putPieces={putPieces}
        checkSaveBtn={checkSaveBtn}
      />
    </>
  )
}

